import React from 'react';
import { Container } from '@mui/material';
import { RichText } from 'prismic-reactjs';
import cs from 'classnames';
import { FooterType } from '@tcs/create-account/utils/prismic/types';
import { Button } from '@forgeglobal/design-framework';
import { useStyles } from './style';

interface FooterProps {
  data: FooterType;
}

const Footer: React.FC<FooterProps> = ({ data }) => {
  const classes = useStyles();
  if (!data) return null;
  const { title, contacts, button_link, button_text, disclaimer } = data;

  return (
    <footer className={classes.footer}>
      <Container disableGutters className={classes.container}>
        <div className={classes.topLine}>
          <div className={classes.contacts}>
            <div className={classes.title}>{title}</div>
            <div className={cs(classes.richText, classes.info)}>
              <RichText render={contacts} />
            </div>
          </div>
          <Button size="medium" color="primary" href={button_link.url}>
            {button_text}
          </Button>
        </div>
        <hr className={classes.divider} />
        <div className={cs(classes.richText, classes.disclaimer)}>
          <RichText render={disclaimer} />
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
